function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, DarkMode, Divider, Text } from '@chakra-ui/react';
import React from 'react';
import LandingNavBar from '../landing/NavBar';
import { FormattedMessage, useIntl } from 'react-intl';
import Footer, { SocialFooter } from '../landing/Footer';
import ContainerStack from '../landing/ContainerStack';
import HeroPanel from '../landing/HeroPanel';
import ScrollCollage from '../landing/ScrollCollage';
import FeaturePanels from '../landing/FeatureSection';
import { LandingPageAnchorIds } from '@/utils/constants';
import { Helmet } from 'react-helmet';
export default function Landing() {
    var intl = useIntl();
    var _React_useState = _sliced_to_array(React.useState(false), 2), showNavBarBackground = _React_useState[0], setShowNavBarBackground = _React_useState[1];
    React.useEffect(function() {
        var handleScroll = function handleScroll() {
            setShowNavBarBackground(window.scrollY > 0);
        };
        handleScroll();
        window.addEventListener('scroll', handleScroll);
        return function() {
            return window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return /*#__PURE__*/ _jsxs(DarkMode, {
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                title: intl.formatMessage({
                    id: "Mqu6qG",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Nightbot"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Box, {
                height: "100vh",
                position: "relative",
                backgroundColor: "backgroundPrimary",
                bgGradient: "radial(ellipse at center bottom, primaryAlpha.500, primaryAlpha.50 75%)",
                children: /*#__PURE__*/ _jsxs(ContainerStack, {
                    height: "100%",
                    children: [
                        /*#__PURE__*/ _jsx(LandingNavBar, {
                            position: "sticky",
                            top: 0,
                            zIndex: 10,
                            transition: "background-color 0.2s",
                            bgColor: showNavBarBackground ? 'primaryAlpha.100' : 'transparent',
                            backdropFilter: "blur(8px)"
                        }),
                        /*#__PURE__*/ _jsx(HeroPanel, {
                            display: "grid",
                            placeItems: "center",
                            paddingX: {
                                base: 8,
                                lg: 16
                            },
                            paddingBottom: 20,
                            height: "100%"
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            right: 0,
                            textAlign: "center",
                            paddingY: 8,
                            color: "textSecondary",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "YWElsW",
                                defaultMessage: "Scroll down to learn more"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(ScrollCollage, {
                id: LandingPageAnchorIds.LEARN_MORE
            }),
            /*#__PURE__*/ _jsx(FeaturePanels, {
                id: LandingPageAnchorIds.FEATURES
            }),
            /*#__PURE__*/ _jsx(Box, {
                position: "relative",
                backgroundColor: "backgroundPrimary",
                borderTopWidth: 1,
                borderColor: "borderTertiary",
                children: /*#__PURE__*/ _jsxs(ContainerStack, {
                    children: [
                        /*#__PURE__*/ _jsx(Footer, {
                            paddingTop: 16,
                            paddingX: {
                                base: 8,
                                lg: 16
                            },
                            spacing: 16
                        }),
                        /*#__PURE__*/ _jsx(Divider, {
                            marginTop: 16
                        }),
                        /*#__PURE__*/ _jsx(SocialFooter, {
                            bgColor: "blackAlpha.100",
                            paddingX: {
                                base: 8,
                                lg: 16
                            }
                        })
                    ]
                })
            })
        ]
    });
}
